(function($) {
    'use strict';

    let HAZE= {
        init: function() {
            // call below defined function on init
            this.lottieAnimation();
            this.changeColorBg();
            this.hoverShapeAnimation();
            this.mainMenuBlock();
            this.themeSelector();
            this.submenuOpener();
            this.fixedHeader();
            this.serviceBlock();
            this.pillsOpener();
            this.awardSlider();
            this.ImageColor();

        },

        ImageColor: function () {
            $.fn.is_on_screen = function(){
                let win = $(window);
                let viewport = {
                    top : win.scrollTop(),
                    left : win.scrollLeft()
                };
                viewport.right = viewport.left + win.width();
                viewport.bottom = viewport.top + win.height();

                let bounds = this.offset();
                bounds.right = bounds.left + this.outerWidth();
                bounds.bottom = bounds.top + this.outerHeight();

                return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
            };

            jQuery(window).on('load resize scroll', function() {
                jQuery.each( jQuery(".image-grid-block"),function(i,e){
                    if (jQuery(e).is_on_screen()) {
                        jQuery(e).addClass('is-visible');
                    }else {
                        jQuery(".image-grid-block").removeClass('is-visible');
                    }
                });
            });
        },
        lottieAnimation: function () {
            if(jQuery('.lottie-animation').length) {
                jQuery('.lottie-animation').each(function () {
                    let json_file = jQuery(this).attr('data-json');
                    if(json_file) {
                        lottie.loadAnimation({
                            container: document.querySelectorAll('.lottie-animation')[0],
                            renderer: 'svg',
                            loop: true,
                            autoplay: true,
                            path: json_file,
                        });
                    }
                });
            }
        },

        changeColorBg: function () {
            function eventSection() {
                let _window = jQuery(window),
                    _body = jQuery('body'),
                    _section = jQuery('section, footer, header');

                let scroll = _window.scrollTop() + (_window.height() / 4);

                _section.each(function () {
                    let _this = jQuery(this);
                    if (_this.position().top <= scroll && _this.position().top + _this.height() > scroll) {

                        _body.removeClass(function (index, css) {
                            return (css.match (/(^|\s)is-bg-\S+/g) || []).join(' ');
                        });

                        if(jQuery(this).data('bg-color') != undefined) {
                            _body.addClass('is-bg-' + jQuery(this).data('bg-color'));
                            jQuery('header').removeClass('active-white-header').addClass('active-dark-header');
                        }else {
                            jQuery('header').removeClass('active-dark-header').addClass('active-white-header');
                        }

                    }
                });
            }
            jQuery(window).on('load resize scroll', function() {
                eventSection();
            });

        },

        hoverShapeAnimation: function () {
            function animateBlock (ele, x, y) {
                jQuery(ele).css({
                    marginTop: (y - 10)/100+'px',
                    marginBottom: (x - 10)/100+'px',
                    marginLeft : (y - 10)/100+'px',
                    marginRight : (x - 10)/100+'px',
                });
            }

            jQuery('section').each(function () {
                if(jQuery(this).find('.section-shape')) {
                    let ele = jQuery(this).find('.section-shape');
                    jQuery(this).on('mousemove', function (e) {
                        let y = e.pageY;
                        let x = e.pageX;
                        animateBlock(ele, x, y);
                    });
                }
            });

            jQuery('.main-menu-block').on('mousemove', function (e) {
                let y = e.pageY;
                let x = e.pageX;
                animateBlock('.menu-block-shape',x,y);
            });
        },

        mainMenuBlock: function () {
            jQuery("header").on('click','.navbar-toggler',function () {
                let _this = this;
                jQuery('body').toggleClass("menu-active");
                jQuery('html').toggleClass("overflow-hidden");
                if (jQuery("body").hasClass("menu-active")) {
                    jQuery(".main-menu-block").animate({ left: "0",opacity: "1" }, 600, function () {
                        jQuery(_this).addClass('open');
                        jQuery('.main-menu-block .menu-item').each(function (i) {
                            jQuery(this).delay(100 * i).animate({ opacity: "1", left: "0px" }, 600);
                        });
                    });
                }else {
                    jQuery('.main-menu-block .menu-item').each(function (i) {
                        jQuery(this).delay(100 * i).animate({ opacity: "0", left: "40px" }, 300);
                    });
                    jQuery(".main-menu-block .menu-item:last-child")
                        .delay(300)
                        .animate({ opacity: "0", left: "40px" }, 500, function () {
                            jQuery(".main-menu-block").animate({ left: "100vw" }, 600, function () {
                                jQuery(".main-menu-block").css({left: "-100vw",opacity: "0"});
                                jQuery(_this).removeClass('open');
                            });
                        });
                }

            });
            // jQuery("header").on("click", ".navbar-toggler", function () {
            //     jQuery("html").toggleClass("menu-active");
            //     jQuery("html").hasClass("menu-active") ? ( jQuery(".main-menu-block").animate({
            //         left: "0"
            //     }, 600, function () {  jQuery(".main-menu-block .nav-item").each(function (e) {
            //         jQuery(this).delay(100 * e).animate({
            //             opacity: "1",
            //             left: "0px"
            //         }, 600)
            //     });
            //     })) : (jQuery("header").css({background: "transparent"
            //     }),  jQuery(".main-menu-block .nav-item").each(function (e) {
            //         jQuery(this).delay(100 * e).animate({
            //             opacity: "0",
            //             left: "80px"
            //         }, 300)
            //     }), jQuery(".main-menu-block .nav-item:last-child").delay(400).animate({
            //         opacity: "0",
            //         left: "80px"
            //     }, 300, function () {
            //         jQuery(".main-menu-block").animate({
            //             left: "-100vw"
            //         }, 600, function () {
            //             jQuery("header").removeAttr("style")
            //         })
            //     }))
            // });
            // var e = 60,
            //     a = 0,
            //     t = !1;
            //
            //
            //

        },

        themeSelector : function () {
            var themeMode = localStorage.getItem("themeMode");

            if(themeMode == 'true') {
                jQuery("body").addClass("dark-theme", this.checked);
                jQuery("header").addClass("dark-header", this.checked);
            }else {
                jQuery("body").removeClass("dark-theme", this.checked);
                jQuery("header").removeClass("dark-header", this.checked);
            }

            jQuery("body.dark-theme").find('#customSwitch1').prop('checked', true);
            jQuery("#customSwitch1").change(function() {
                jQuery("body").toggleClass("dark-theme", this.checked);
                jQuery("header").toggleClass("dark-header", this.checked);
                if(jQuery('body').hasClass('dark-theme')) {
                    localStorage.setItem('themeMode', JSON.stringify(true));
                }else {
                    localStorage.setItem('themeMode', JSON.stringify(false));
                }
            }).change();
        },

        submenuOpener : function () {
            jQuery( ".navbar-nav .submenu-opener" ).on('click', function( e ) {
                e.preventDefault();

                if ( !jQuery( this ).hasClass( 'closed' ) ) {
                    jQuery( this ).addClass( 'closed' );
                    jQuery( this ).next('ul.dropdown-menu').slideToggle();
                }
                else {
                    jQuery( this ).removeClass( 'closed' );
                    jQuery( this ).next('ul.dropdown-menu').slideToggle();
                }

            });

        },

        fixedHeader : function () {
            function stickyMenu() {
                var sticky = jQuery('header'),
                    scroll = jQuery(window).scrollTop();

                if (scroll >= 30) sticky.addClass('fixed');
                else sticky.removeClass('fixed');
            }
            stickyMenu();
            jQuery(window).scroll(function(){
               stickyMenu();
            });
        },

        serviceBlock : function () {
            // jQuery('.service-block').on('click', '.single-service-box', function(evt) {
            //     var _this = this;
            //
            //     jQuery('html').addClass('fixedbody');
            //     jQuery('.service-block .service-boxes').addClass('active');
            //
            //
            //
            //     if ( !jQuery( this ).hasClass( 'active' ) ) {
            //         jQuery('.service-block .single-service-box.active').removeClass('active');
            //         jQuery( this ).addClass( 'active' );
            //     }
            //     else {
            //         jQuery( this ).toggleClass( 'active' );
            //         jQuery('html').removeClass('fixedbody');
            //         jQuery('.service-block .service-boxes').removeClass('active');
            //     }
            //
            //     setTimeout(function (){
            //         jQuery('.service-boxes.active').animate({
            //             scrollTop: jQuery(_this).offset().top
            //         }, 500);
            //         // console.log(jQuery('.service-boxes').height()/2);
            //     },500);
            // });
        },

        pillsOpener: function() {
            jQuery('.pills-opener').on('click', function () {

                jQuery('.pills-tab-wrapper').toggleClass('open-navpills');

            });

            jQuery('.pills-tab-wrapper a.nav-link').on('click', function () {

                jQuery('.pills-tab-wrapper').removeClass('open-navpills');

            });
        },

        awardSlider : function () {
            jQuery('.award-slider').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
            });

            jQuery('#award1').on('click', function (e) {
                jQuery('#award-slider1').addClass('active');
                jQuery('html').addClass('fixedbody');
            });

            jQuery('#award-slider1 .close-button img').on('click', function (e) {
                jQuery('#award-slider1').removeClass('active');
                jQuery('html').removeClass('fixedbody');
            });



        },
    };
    HAZE.init();

})(jQuery);





